
export default function Loader(){
    return(
        <span class="loader"></span>
    )
}